import axiosInstance from "../config/axiosIntance";
import { getDraftByIdResponse } from "../types";

type Params = {
  draftId: string;
  token: string;
};

export const getDraftsHistoryByIdService = async ({
  token,
  draftId
}: Params): Promise<getDraftByIdResponse> => {
  const dataFetched = await axiosInstance.get(`/consent-config//draft/history/draftsTemplates/${draftId}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });

  return dataFetched.data;
};
